module.exports = __webpack_public_path__ + "assets/0e53588208d7b5dd34bd4927f08ea417.png";